import ConfirmActiveRouter from './router/confirm-active-router';

export default ConfirmActiveRouter;
